/* Material strips (§10.6). One strip open at a time: click / Enter / Space on its button, hover
   (mouse, 120ms intent) or selecting its block in the theme editor. Collapsed text is inert and
   aria-hidden, so what's announced matches what's shown. */
class MaterialStrips extends HTMLElement {
  connectedCallback() {
    this.strips = [...this.querySelectorAll('[data-strip]')];
    this.fine = matchMedia('(hover: hover) and (pointer: fine)');
    this.onClick = (event) => {
      const button = event.target.closest('[data-strip-button]');
      if (button) this.activate(button.closest('[data-strip]'));
    };
    this.onOver = (event) => {
      if (event.pointerType !== 'mouse' || !this.fine.matches) return;
      const strip = event.target.closest('[data-strip]');
      clearTimeout(this.timer);
      if (strip) this.timer = setTimeout(() => this.activate(strip), 120);
    };
    this.onBlockSelect = (event) => {
      if (this.strips.includes(event.target)) this.activate(event.target);
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('pointerover', this.onOver);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
    this.sync();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  activate(strip) {
    if (!strip || strip.classList.contains('is-active')) return;
    this.strips.forEach((other) => other.classList.toggle('is-active', other === strip));
    this.sync();
  }

  sync() {
    this.strips.forEach((strip) => {
      const open = strip.classList.contains('is-active');
      strip.querySelector('[data-strip-button]').setAttribute('aria-expanded', String(open));
      const content = strip.querySelector('.strip__content');
      content.toggleAttribute('inert', !open);
      content.setAttribute('aria-hidden', String(!open));
    });
  }
}

if (!customElements.get('material-strips')) customElements.define('material-strips', MaterialStrips);
